import { SearchOutlined, DownOutlined } from "@ant-design/icons";
import { Dropdown, MenuProps } from "antd";

import { RootState } from "../../../../redux/store";
import { useSelector } from "react-redux";

function SelectReplaceDropdown(props: any) {
  const replaceHistory = useSelector((state: RootState) => state.qCDetailPageState.replaceHistory);
  const searchHandleMenuClick: MenuProps["onClick"] = (e) => {
    props.setReplaceTextValue(e.key);
  };
  const replaceMenuProps = {
    items: replaceHistory.map((item: string) => ({
      key: item,
      label: item,
    })),
    onClick: searchHandleMenuClick,
  };
  const noValueSearchMenuProps = {
    items: [{ label: "No previous replace", key: "No previous replace" }],
    onClick: () => {},
  };
  return (
    <Dropdown
      menu={replaceHistory.length === 0 ? noValueSearchMenuProps : replaceMenuProps}
      trigger={["click"]}>
      <div className="dropdown-btn">
        <SearchOutlined />
        <DownOutlined />
      </div>
    </Dropdown>
  );
}

export default SelectReplaceDropdown;
